export const Sakura = () => {
	return (
		<div className="sakura-container absolute top-0 left-0 w-full h-full z-40 pointer-events-none">
			<div className="camera -x">
				<div className="camera -y">
					<div className="camera -z">
						{[...Array(20)].map((_, index: number) => (
							<div key={index} className="drop">
								<div className="z">
									<div className="slide">
										<div className="move">
											<div className="stagger">
												<div className="reverse">
													<div className="rotate">
														<div className="size">
															<div className="sakura">
																<img
																	src={require('@/assets/images/sakura.png')}
																	alt="sakura"
																/>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						))}
					</div>
				</div>
			</div>
		</div>
	)
}
